import React, { useState } from 'react';
import { ChevronLeft, ChevronRight, LogOut, User, Lock, Info, Settings, Bell } from 'lucide-react';
import { useLanguage } from '../components/LanguageContext';
const USER_AVATAR_URL = 'https://cdn.magicpatterns.com/uploads/9KSQW1TfFTA7NGLfA1xyeD/Screenshot_2026-04-22_alle_14.07.40.png';
interface Props {
  onBack?: () => void;
  onLogout?: () => void;
}
export function ProfilePage({
  onBack,
  onLogout
}: Props) {
  const {
    t
  } = useLanguage();
  const menuItems = [{
    icon: User,
    label: 'Account',
    color: 'text-white'
  }, {
    icon: Lock,
    label: 'Password & Sicurezza',
    color: 'text-white'
  }, {
    icon: Bell,
    label: 'Notifiche',
    color: 'text-white'
  }, {
    icon: Info,
    label: 'Informazioni',
    color: 'text-white'
  }, {
    icon: Settings,
    label: 'Impostazioni',
    color: 'text-white'
  }];
  return <div className="flex flex-col h-full w-full bg-[#0D0D0D] overflow-hidden" data-id="element-891">
      {/* Header with back button */}
      <header className="px-5 pt-6 pb-4 flex items-center gap-3 shrink-0 border-b border-[#2A2A2A]/50" data-id="element-892">
        {onBack && <button onClick={onBack} aria-label={t('common.back')} className="w-10 h-10 -ml-2 flex items-center justify-center rounded-full active:bg-[#141414]" data-id="element-893">
            <ChevronLeft className="w-6 h-6 text-white" strokeWidth={2} data-id="element-894" />
          </button>}
        <h1 className="page-title text-[20px] font-[500]" data-id="element-895">Profilo</h1>
      </header>

      {/* Scrollable Content */}
      <div className="flex-1 overflow-y-auto min-h-0 px-6 pt-8 pb-24" data-id="element-896">
        {/* Profile Picture & Name */}
        <div className="flex flex-col items-center mb-8" data-id="element-897">
          <div className="w-24 h-24 rounded-full border-2 border-[#2A2A2A] overflow-hidden mb-4" data-id="element-898">
            <img src={USER_AVATAR_URL} alt="Profile" className="w-full h-full object-cover" data-id="element-899" />
          </div>
          <h2 className="text-[20px] text-white font-semibold mb-1" data-id="element-900">
            Marco Rossi
          </h2>
          <p className="text-[13px] text-[#A0A0A0]" data-id="element-901">CEO / Founder · EIIS</p>
        </div>

        {/* Menu Items */}
        <div className="bg-[#141414] rounded-[16px] border border-[#2A2A2A] overflow-hidden mb-6" data-id="element-902">
          {menuItems.map((item, index) => <button key={item.label} className={`w-full flex items-center gap-3 px-4 py-4 hover:bg-[#1A1A1A] transition-colors ${index < menuItems.length - 1 ? 'border-b border-[#2A2A2A]' : ''}`} data-id="element-903">
              <item.icon className="w-5 h-5 text-[#888888]" strokeWidth={2} data-id="element-904" />
              <span className="flex-1 text-left text-[14px] text-white font-medium" data-id="element-905">
                {item.label}
              </span>
              <ChevronRight className="w-4 h-4 text-[#555555]" strokeWidth={2} data-id="element-906" />
            </button>)}
        </div>

        {/* Logout */}
        <button onClick={onLogout} className="w-full flex items-center justify-center gap-2 py-4 rounded-[14px] border border-[#D32F2F]/30 text-[#D32F2F] text-[14px] font-semibold hover:bg-[#D32F2F]/5 transition-colors" data-id="element-907">
          <LogOut className="w-4 h-4" strokeWidth={2} data-id="element-908" />
          Logout
        </button>
      </div>
    </div>;
}